module.exports = __webpack_public_path__ + "img/undraw_shopping.0dd7c247.svg";